import { ButtonProps } from '@mui/material';
import classNames from 'classnames';
import Iconify from 'src/components/iconify';
import { useLocales } from 'src/locales';
import { CustomActionButton } from './styles';

export const AiSendButton = ({
  onClick,
  isFromNav,
}: ButtonProps & { isFromNav?: boolean }) => {
  const { translate } = useLocales();
  return (
    <CustomActionButton
      color="primary"
      variant="contained"
      onClick={onClick}
      tooltip={translate('communicate.rtc_controls.send_record_to_copera_ai')}
      className={classNames({ isFromNav })}
    >
      <Iconify icon="tabler:arrow-up" color="white" />
    </CustomActionButton>
  );
};
